import { styled } from 'styled-components'

export const Page = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 0;
`
